export default __webpack_public_path__ + "static/media/frg--indoor-pool.f3fbaf39.png";